import { imageAssets } from '@/assets/images'
import type { WebsiteContent } from './types'

export const industries: WebsiteContent['industries'] = {
  subtitle: 'We partner with…',
  description:
    'Every engagement is built around human-first AI outcomes that are practical, measurable, and ready to scale.',
  groups: [
    {
      name: 'Retail & Ecommerce',
      description:
        'Every customer is unique, but most retailers treat them like a statistic. We build AI that creates personal connections at scale.',
      image: imageAssets.industries.retailEcommerce,
      exampleMedia: {
        type: 'image',
        src: imageAssets.industries.retailEcommerceWork,
        alt: 'Retail shopper using an AI-assisted beauty recommendation experience',
      },
      highlights: [
        'Smarter Market Insights - Trend insights pipeline for a major fashion e-tailer',
        'Predictive Audience Modeling - Using synthetic customers for deep, actionable consumer insights',
      ],
      exampleTitle: 'The Beauty Agent That Gets You',
      exampleDescription:
        'A virtual beauty consultant that actually understands what customers need and enables frictionless commerce transactions.',
    },
    {
      name: 'Finance & Insurance',
      description:
        'Our AI helps you understand risk, serve customers better, and make claims actually work for everyone.',
      image: imageAssets.industries.financeInsurance,
      exampleMedia: {
        type: 'image',
        src: imageAssets.industries.financeInsuranceWork,
        alt: 'Financial dashboard showing AI-prioritized leads and campaign performance signals',
      },
      highlights: [
        'Intelligent Lead Prioritization - Enrichment and list-building agents to identify high-value',
        'Agentic Risk Scoring - Gather customer data through conversational AI to mitigate risk exposure',
      ],
      exampleTitle: 'Campaigns That Think for Themselves',
      exampleDescription:
        'Real-time intelligence that turns campaign data into actionable insights without the spreadsheet headaches.',
    },
    {
      name: 'Healthcare & Life Sciences',
      description:
        'Nothing is more personal than healthcare, making our human-centered approach to AI a natural fit.',
      image: imageAssets.industries.healthcareLifeSciences,
      exampleMedia: {
        type: 'image',
        src: imageAssets.industries.healthcareLifeSciencesWork,
        alt: 'Healthcare team reviewing AI-supported patient insights and risk indicators',
      },
      highlights: [
        'Healthcare That Prevents, Not Just Treats - Building AI that spots health issues before they become problems, putting patients back in control',
        'Immersive Patient Research Lab - Improve patient understanding with interactive digital',
      ],
      exampleTitle: 'AI That Puts Patients First',
      exampleDescription:
        'AI that helps healthcare professionals sift through growing volumes of patient data, improving outcomes and efficiency.',
    },
    {
      name: 'Higher Education',
      description:
        "Every student's path is different. We build AI that understands this, creating personalized experiences that help students succeed, not just graduate.",
      image: imageAssets.industries.higherEducation,
      exampleMedia: {
        type: 'image',
        src: imageAssets.industries.higherEducationWork,
        alt: 'College student onboarding journey guided by an AI assistant interface',
      },
      highlights: [
        'Personal Onboarding Assistant - An AI-powered guide to simplify student onboarding from application to matriculation.',
        'AI Vision & Strategy - Develop a strategic vision and roadmap for university-wide AI integration',
      ],
      exampleTitle: 'Making College Work for Students',
      exampleDescription:
        'AI that guides students through their entire journey, from application to matriculation to career success.',
    },
  ],
}
